<section class="car-identification" dir="rtl">
  <div class="identification-switch" role="tablist" aria-label="אופן הזנת פרטי הרכב">
    <button
      type="button"
      role="tab"
      [class.is-active]="isLicenceCode"
      [attr.aria-selected]="isLicenceCode"
      (click)="switchFunc('licenceCode')">
      <mat-icon aria-hidden="true">pin</mat-icon>
      <span>{{'sale4u.label.licenceCode' | translate}}</span>
    </button>
    <button
      type="button"
      role="tab"
      [class.is-active]="!isLicenceCode"
      [attr.aria-selected]="!isLicenceCode"
      (click)="switchFunc('manual')">
      <mat-icon aria-hidden="true">edit_note</mat-icon>
      <span>{{'sale4u.label.manual' | translate}}</span>
    </button>
  </div>

  @if (isLicenceCode) {
    <div
      class="license-panel navigation-question"
      role="tabpanel"
      [attr.data-navigation-order]="navigationStartOrder">
      <div class="license-heading">
        <span class="heading-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="3" y="5" width="18" height="14" rx="3"></rect>
            <path d="M7 9h10M7 13h6"></path>
          </svg>
        </span>
        <span>
          <strong>איתור מהיר לפי מספר רישוי</strong>
          <small>נמלא עבורכם את פרטי הרכב אוטומטית</small>
        </span>
      </div>

      <form [formGroup]="licenceCodeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="license-form-row">
          <label class="license-field">
            <span class="field-label">מספר הרישוי של הרכב</span>
            <span class="israeli-plate" [class.has-error]="licenseControl.touched && licenseControl.invalid">
              <span class="plate-country" aria-hidden="true">
                <strong>IL</strong>
                <span>ישראל</span>
              </span>
              <input
                type="text"
                class="input-field-focus"
                formControlName="licenceCode"
                inputmode="numeric"
                autocomplete="off"
                maxlength="10"
                placeholder="12-345-67"
                aria-label="מספר רישוי"
                (input)="onLicenseInput($event)" />
            </span>
            @if (licenseControl.touched && licenseControl.invalid) {
              <span class="field-error">יש להזין מספר רישוי תקין בן 7 או 8 ספרות</span>
            } @else {
              <span class="field-hint">ללא צורך בהקלדת מקפים</span>
            }
          </label>

          <button class="search-button" type="submit" [disabled]="licenseControl.invalid || isSearching">
            @if (isSearching) {
              <span class="button-spinner" aria-hidden="true"></span>
              <span>מחפשים רכב...</span>
            } @else {
              <mat-icon aria-hidden="true">search</mat-icon>
              <span>{{"sale4you.label.car.search" | translate}}</span>
            }
          </button>
        </div>

        @if (error) {
          <div class="lookup-message error-message" role="alert">
            <mat-icon aria-hidden="true">error_outline</mat-icon>
            <span>{{ error }}</span>
          </div>
        }

        @if (licenseCodeDes) {
          <div class="vehicle-result" aria-live="polite">
            <div class="result-heading">
              <span class="result-check" aria-hidden="true"><mat-icon>check</mat-icon></span>
              <span>
                <strong>הרכב נמצא בהצלחה</strong>
                <small>הפרטים הבאים נוספו לטופס באופן אוטומטי</small>
              </span>
              <button type="button" class="change-license" (click)="onReset()">חיפוש מספר אחר</button>
            </div>

            <div class="vehicle-title">
              <mat-icon aria-hidden="true">directions_car</mat-icon>
              <strong>{{ licenseCodeDes.producer }} {{ licenseCodeDes.commercialNickname }}</strong>
              <span>{{ licenseCodeDes.year }}</span>
            </div>

            <div class="vehicle-specs">
              <span><small>נפח מנוע</small><strong>{{ licenseCodeDes.engineCapacity }} סמ״ק</strong></span>
              <span><small>הספק</small><strong>{{ licenseCodeDes.hp }} כ״ס</strong></span>
              <span><small>סוג דלק</small><strong>{{ licenseCodeDes.fuel || '—' }}</strong></span>
              <span><small>הנעה</small><strong>{{ licenseCodeDes.fourWheelDrive || '—' }}</strong></span>
              <span><small>רמת גימור</small><strong>{{ licenseCodeDes.finishLevel || '—' }}</strong></span>
              <span><small>מספר מושבים</small><strong>{{ licenseCodeDes.seats || '—' }}</strong></span>
            </div>
          </div>
        }
      </form>
    </div>
  } @else {
    <div class="manual-panel" role="tabpanel">
      <div class="manual-heading">
        <mat-icon aria-hidden="true">edit_note</mat-icon>
        <span>
          <strong>הזנת פרטי רכב ידנית</strong>
          <small>בחרו את היצרן, הדגם והשנה בשדות הבאים</small>
        </span>
      </div>
      <div id="questionContainer" class="manual-questions">
        @for (question of questions; track question.key) {
          <div
            class="navigation-question"
            [attr.data-navigation-order]="getNavigationOrder(question.key)">
            <app-question [question]="question" [form]="form"></app-question>
          </div>
        }
      </div>
    </div>
  }
</section>
